export default "__VITE_ASSET__CiVo39wo__"